import ky from 'ky';

import {ReduxStateApplicableAPIFilters} from '~redux/types/filters';

import {getOptions} from './api';

const AUTH_API = import.meta.env.VITE_AUTH_API ?? '';

export const getFilters = (projectID: string): Promise<Partial<ReduxStateApplicableAPIFilters>> =>
  ky
    .get(`${AUTH_API}/filters/${projectID}`, getOptions({apiVersion: 3, signalId: 'getFilters'}))
    .json<Partial<ReduxStateApplicableAPIFilters>>();
